import  { useState, useEffect } from 'react'
import { Button, Modal, Row, Col, Select, Input, message } from 'antd'
import req from '../request'

const App = props => {
    const [visible,setVisible] = useState(false)
    const [status,setStatus] = useState(null)
    const [comment,setComment] = useState(null)

    const changeStatus = newStatus => {

        req.post('/api/return',{action:'changeReturnState',newstatus:newStatus,id:props.item.id}).then(r=>{
            // console.log(r)
            if(r.status==='done'){
                message.success('修改成功')
                props.refresh && props.refresh()
            }else{
                message.error(r.msg)
            }
        })
    }
    const addComment = () => {
        // console.log(comment);
        req.post('/api/return',{action:'addLogs',comment:comment,id:props.item.id}).then(r=>{
            if(r.status === 'done'){
                setVisible(false)
                message.success('新增成功')
                props.refresh && props.refresh()
            }else{
                message.error(r.msg)
            }
        })
    }

    useEffect(()=>{
        setStatus(props.item ? props.item.status : null) // eslint-disable-next-line
    },[])
    if(props.item)
    return <>
        <Button onClick={()=>setVisible(!visible)} size={props.size ? props.size : 'small'} type={props.type ? props.type : 'dashed'}>
            {props.children ? props.children : '操作'}
        </Button>
        <Modal 
            onOk={addComment}
            title={'操作退返数据:' + props.item.id +'. 你可以' } 
            visible={visible}
            // onOk={handleOk} 
            onCancel={()=>setVisible(false)}
        >
            <Row gutter={5} style={{paddingBottom:'10px'}}>
                <Col>修改状态:</Col>
                <Col><ChangeStatus value={status} onChange={changeStatus} /></Col>
            </Row>
            <Row style={{paddingBottom:'10px'}}>
                <Col>or 新增跟进:</Col>
                <Col><Button size='small' onClick={() => setComment('空号')} type='link'>空号</Button></Col>
                <Col><Button size='small' onClick={() => setComment('停机')} type='link'>停机</Button></Col>
                <Col><Button size='small' onClick={() => setComment('关机')} type='link'>关机</Button></Col>
                <Col><Button size='small' onClick={() => setComment('一次不接')} type='link'>一次不接</Button></Col>
                <Col><Button size='small' onClick={() => setComment('两次不接')} type='link'>两次不接</Button></Col>
                <Col><Button size='small' onClick={() => setComment('三次不接')} type='link'>三次不接</Button></Col>
            </Row>
            <Row>
                <Col><Input.TextArea value={comment} rows={4} onChange={t=>setComment(t.target.value)} style={{width:'400px'}} /></Col>
            </Row>
        </Modal>
    </>
    else
    return <>无数据</>
}

const ChangeStatus = props => {
    return <Select 
            value={props.value ? props.value : null} 
            size='small' 
            style={{width: '130px'}}
            onChange={e=>props.onChange && props.onChange(e)}
        >
        <Select.Option value='非该项目'>非该项目</Select.Option>
        <Select.Option value='超时'>超时</Select.Option>
        <Select.Option value='处理中'>处理中</Select.Option>
        <Select.Option value='退补待审核'>退补待审核</Select.Option>
        <Select.Option value='已作废'>已作废</Select.Option>
        <Select.Option value='不在退补范围'>不在退补范围</Select.Option>
    </Select>
}

export default App